import React from "react";
import { DragSource } from "react-dnd";

const engineerSource = {
  canDrag(engineerProps) {
    // You can decide if dragging is available based on the
    // props of the engineer.
    // Here I assume it is always available
    // This is the equivalent of "return true".
    // I just write it like this so "engineerProps" gets used.
    return !!engineerProps;
  },

  isDragging(engineerProps, monitor) {
    // The monitor keeps track of what is the dragged item
    // at the level of the entire drag area
    // The result of this method is injected as the property
    // 'isDragging' in the engineer.

    // When monitor.getItem is called without parameters, it returns the
    // item which is being dragged.
    return monitor.getItem().id === engineerProps.id;
  },

  beginDrag(props, monitor, component) {
    // This is what is put in the monitor context when an engineer
    // is being dragged.
    /*** Warning: This is all figured by looking at the code in react-big-calendar. Not sure if they have docs ***/
    return {
      id: props.id, // The id is being used by hte monitor to keep track which item is dragged. See isDragging above.
      anchor: "drop", // The anchor decides which callback is invoked when the engineer is dropped
      // In our case, anchor: 'drop' means that onDrop will be called.
      event: {
        // The event is what is passed to the onDrop method when the engineer is dropped.
        id: props.id,
        name: props.name,
      },
    };
  },
};

/**
 * Specifies which props to inject into the engineer component.
 */
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

class Engineer extends React.Component {
  render() {
    const { connectDragSource } = this.props;
    return connectDragSource(
      <div id={`engineer-${this.props.id}`} className="rbc-event">
        {this.props.name}
      </div>,
    );
  }
}

// "event" here is hardcoded in react-big-calendar when the DropTarget is set there
// The engineerSource and collect are defined above
// Based on the react-dnd example from
// http://react-dnd.github.io/react-dnd/docs-drag-source.html
export const DraggableEngineer = DragSource("event", engineerSource, collect)(
  Engineer,
);

// The list of draggable engineers
export default ({ engineers }) =>
  engineers.map((engineer, key) => (
    <DraggableEngineer key={key} id={-engineer.id} name={engineer.name} />
  ));



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/calendar/Engineers.js